import React from "react";
import Js from "../../../assets/Tech-Page-Assets/Js.png";
import Reactpic from "../../../assets/Tech-Page-Assets/React.png";
import Html from "../../../assets/Tech-Page-Assets/Html5.png";
import Php from "../../../assets/Tech-Page-Assets/Php.png";
import Node from "../../../assets/Tech-Page-Assets/Node.png";
import Sanity from "../../../assets/Tech-Page-Assets/Sanity.png";
import Express from "../../../assets/Tech-Page-Assets/Express.png";
import Tailwind from "../../../assets/Tech-Page-Assets/Tailwind.png";
import Mongo from "../../../assets/Tech-Page-Assets/MongoDB.png";
import MySql from "../../../assets/Tech-Page-Assets/MySql.png";
import Firebase from "../../../assets/Tech-Page-Assets/Firebase.png";
import Css from "../../../assets/Tech-Page-Assets/Css3.png";

const logos = [
  {
    id: 1,
    logos: Js,
    title: "JavaScript",
  },
  {
    id: 2,
    logos: Reactpic,
    title: "React",
  },
  {
    id: 3,
    logos: Html,
    title: "Html",
  },
  {
    id: 4,
    logos: Php,
    title: "Php",
  },
  {
    id: 5,
    logos: Node,
    title: "Node.js",
  },
  {
    id: 6,
    logos: Sanity,
    title: "Sanity",
  },
  {
    id: 7,
    logos: Express,
    title: "Express.js",
  },
  {
    id: 8,
    logos: Tailwind,
    title: "Tailwind",
  },
  {
    id: 9,
    logos: Mongo,
    title: "MongoDB",
  },
  {
    id: 10,
    logos: MySql,
    title: "MySql",
  },
  {
    id: 11,
    logos: Firebase,
    title: "Firebase",
  },
  {
    id: 12,
    logos: Css,
    title: "CSS",
  },
];

const Logos = () => {
  return (
    <div className="logo-block">
      <div className="container">
        <div className="logos-container">
          {logos.map((logo) => (
            <div key={logo.id} className="logos">
              <img src={logo.logos} alt={logo.title} />
              <p>{logo.title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Logos;
